export const selfLearningVideoUrl = (data) => dispatch => {
    dispatch({
        type: 'VIDEO_URL',
        payload: data
    });
};